import { Fragment } from "react";
import { Link } from "react-router-dom";
import style from "./footer.module.css"
// import "./footer.css"

export default function Footer() {


   return (
      <Fragment>
         <footer className={`footer bgBlack mt-5 py-3 text-white text-center ${style.userFooter} `}>
            <div className="container-fluid p-4 ">
               <h3 className="header-title-text m-0 d-flex justify-content-center align-items-center gap-1">
                  <span className="text-white">SMART</span>
                  <span className="ps-1 ">TREND</span>
               </h3>
               <div className="row">

                  <div className="col-md-12">
                     <p className="footer-info fs-sm">
                        منصة إلكترونية مجانية تقدم   خدمات  الرعاية الصحية
                        (الخدمات  الطبية والأشعة التشخيصية)، ويتوفر لدينا الحجز
                        والدفع الإلكتروني (طرق دفع متعددة)، للمساهمة في خفض
                        تكاليف الخدمة، من خلال شبكة تتكون
                        من العديد من أشهر مقدمي
                        الخدمة الطبية من معامل تحاليل
                        طبية ومراكز أشعة بجميع محافظات
                        مصر، تتيح منصة سمارت تريند حجز الخدمات
                        الطبية لنفسك أو للأخرين بخصومات تصل
                        إلي 50%، كما تتيح أيضا مقارنة الأسعار
                        بين مقدمي الخدمات  الطبية المختلفة
                        وإختيار الأنسب من حيث
                        السعر والتقييم والخدمات .
                     </p>
                  </div>

                  <div className="row mt-4 mx-0 justify-content-center">

                     {/* <div className="hstack gap-1 col-md-6">
                        <input className="form-control me-auto py-1 px-3" type="text" placeholder="Add your Notes here..." aria-label="Add your item here..." />
                        <div className="vr" />
                        <button type="button" className="btn btn-sm btn-danger ">Submit</button>
                     </div> */}



                     <div className="col-md-6">
                        <div className="d-flex justify-content-center align-items-center parentIcon">
                           <Link className="cartIconFooter" to="https://www.facebook.com/share/1BmHc3BN6e/">
                              <i className="fa-brands  fa-facebook text-white"></i>
                           </Link>
                           <Link className="cartIconFooter">
                              <i className="fa-brands  fa-twitter text-white"></i>
                           </Link>
                           <Link className="cartIconFooter">
                              <i className="fa-brands  fa-telegram text-white"></i>
                           </Link>
                           <Link className="cartIconFooter" to="https://www.instagram.com/smarttrendcompany/profilecard/?igsh=dnE1aWN4Y3FxdWs3">
                              <i className="fa-brands  fa-instagram text-white"></i>
                           </Link>
                           <Link className="cartIconFooter" to="https://wa.me/201066991090" >
                              <i className="fa-brands fa-whatsapp text-white"></i>
                           </Link>
                        </div>

                        <div className="my-2">
                           <Link to="/PrivacyPolicy"
                              rel="noopener noreferrer"
                              className={`${style.policy} text-white fs-6`}>سياسة الخصوصية  - سياسة الاسترجاع -  الشروط والاحكام</Link>
                        </div>
                     </div>



                  </div>

               </div>
            </div>
            <p className="p-2 m-0 text-white developer">CopyRight &copy; SMART TREND -  Developed By : <Link className="" to="#">M-E <span className="second-color">Group</span></Link></p>
         </footer>
      </Fragment>
   )
}